import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c6cf139"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "office-name" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = { class: "foreground-area" }
const _hoisted_4 = { class: "p-3 border-bottom border-gray-03" }
const _hoisted_5 = { class: "text-weight-500" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "office-actions mt-2" }
const _hoisted_8 = { class: "p-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-weight-500 text-mild" }, "責任者", -1))
const _hoisted_10 = {
  key: 0,
  class: "operation-tags"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "など", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BImgLazy = _resolveComponent("BImgLazy")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_EvaluationWithCount = _resolveComponent("EvaluationWithCount")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_OfficeMuteButton = _resolveComponent("OfficeMuteButton")!
  const _component_GreetingMessage = _resolveComponent("GreetingMessage")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.officeName), 1),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_BImgLazy, {
        src: _ctx.optimizedOrderImage,
        alt: "",
        class: "office-image"
      }, null, 8, ["src"]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Tag, {
          label: _ctx.officeServiceName,
          class: "office-service-tag"
        }, null, 8, ["label"])
      ])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.address), 1),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.evaluationTotalAverage)
            ? (_openBlock(), _createBlock(_component_EvaluationWithCount, {
                key: 0,
                value: _ctx.evaluationTotalAverage,
                count: _ctx.evaluationCount
              }, null, 8, ["value", "count"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_FavoriteButton, {
          isFavorite: _ctx.isFavorite,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('favorite-change', $event)))
        }, null, 8, ["isFavorite"]),
        _createTextVNode(),
        _createVNode(_component_OfficeMuteButton, {
          isMuted: _ctx.isMutedOffice,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change-muted-office', $event)))
        }, null, 8, ["isMuted"])
      ])
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _hoisted_9,
        _createTextVNode(),
        _createVNode(_component_GreetingMessage, {
          class: "greeting-message",
          firstName: _ctx.getOfficeProp('managerFirstName'),
          lastName: _ctx.getOfficeProp('managerLastName'),
          personImage: _ctx.getOfficeProp('managerAvatar'),
          message: _ctx.getOfficeProp('greetingMessage')
        }, null, 8, ["firstName", "lastName", "personImage", "message"])
      ]),
      _createTextVNode(),
      (_ctx.limitedOperations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limitedOperations, (operation) => {
              return (_openBlock(), _createBlock(_component_Tag, {
                key: operation.id,
                label: operation.name,
                class: "bg-light-yellow border-yellow text-primary-dark"
              }, null, 8, ["label"]))
            }), 128)),
            _createTextVNode(),
            _hoisted_11
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}